import { BOWLER_REQUEST, BOWLER_SUCCESS, BOWLER_FAILURE } from '../actions/bowler'

const INITIAL_STATE = {
  data: null,
  loading: false,
  error: null,
}

const bowlerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BOWLER_REQUEST:
      return { ...state, loading: true, error: null }
    case BOWLER_SUCCESS:
      return { ...state, loading: false, data: action.response, error: null }
    case BOWLER_FAILURE:
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}

export default bowlerReducer
